<template>
  <carousel
    class="carousel"
    ref="carouselSelector"
    :navigationEnabled="false"
    :per-page="1"
    :pagination-enabled="false"
    :loop="true"
    :autoplay="true"
    :autoplay-timeout="5000"
    easing="a"
    :minSwuipeDistance="2"
  >
    <slide align="center" v-for="(item, index) in items" :key="index">
      <div
        class="banner__image"
        :style="'background-image: url(' + item.banner + ')'"
      ></div>
      <div class="infos">
        <h6 class="banner_name">{{ item.name }}</h6>
        <p>{{ item.mini_bio }}</p>
        <div
          class="logo-p"
          :style="'background-image: url(' + item.logo + ')'"
        ></div>
      </div>
    </slide>
  </carousel>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  props: ["items"],
  data() {
    return {
      width: screen.width,
      logo: "http://localhost/img/mastercard.png",
    };
  },
  components: {
    Carousel,
    Slide,
  },
  methods: {
    navigateTo(index) {
      this.slider = index;
      this.$refs.carouselSelector.goToPage(index);
    },
  },
  mounted() {
    setTimeout(() => {
      this.$refs["carouselSelector"].onResize();
      this.$refs["carouselSelector"].goToPage(0);
    }, 200);
  },
};
</script>

<style lang="scss" rel="stylesheet" media="all">
@import "resources/assets/sass/website/_variables.scss";

.carousel {
  margin-top: -80px;
  width: 100%;
  height: 85vh;
  @media (min-width: 1500px) {
    height: 100vh;
    margin-top: -200px;
  }
  @media (max-width: 996px) {
    margin-top: 30px;
    height: 600px;
  }
  @media (max-width: 500px) {
    margin-top: -20px;
    height: 600px;
  }
  @media (max-width: 400px) {
    margin-top: -50px;
  }

  .slide {
    position: relative;
    @media (max-width: 575px) {
      margin-bottom: 50px;
    }
  }

  .banner__image {
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    height: 550px;
    position: relative;
    @media (min-width: 1500px) {
      height: 900px;
    }
    @media (max-width: 500px) {
      height: 600px;
    }
  }
  .infos {
    display: flex;
    flex-direction: column;
    position: absolute;
    bottom: 200px;
    min-height: 270px;
    @media (max-width: 1500px) {
      bottom: 30px;
    }
    .banner_name {
      color: $green-water;
      font-family: $font-geo;
      display: flex;
      text-align: left;
      font-weight: bold;
      font-size: 30px;
      line-height: 110%;
      width: 200px;
      @media (max-width: 500px) {
        font-size: 20px;
      }
    }
    p {
      font-family: $font-geo;
      color: $white;
      font-size: 16px;
      width: 200px;
      line-height: 16px;
      text-align: left;
      @media (max-width: 500px) {
        font-size: 13px;
      }
    }

    .logo-p {
      background-repeat: no-repeat;
      background-size: contain;
      width: 150px;
      height: 50px;
    }
  }
}
</style>
